<template>
  <div class="leftBanner">
    <!-- 最左边自己的头像和洽谈按钮 -->
    <v-img
      class="myIcon"
      :src="
        ((currentUser.memberCard && currentUser.memberCard.cardAvatar) || DEFAULTS_AVATAR_BIG) +
        '?x-oss-process=image/resize,m_fixed,h_44,w_44'
      "
      @click="toHomePage(currentUser ? currentUser.unicode || currentUser.memunicode : '')"
      @mouseenter="getMyCard"
      @mouseout="
        () => {
          isShowMyCard = false
        }
      "
    />
    <div style="margin-top: 20px">
      <a-badge
        :count="talkUnReadNum"
        :offset="[-10, 5]"
        :number-style="{
          fontSize: '12px',
        }"
      >
        <v-img :src="ICON_CHAT_DOT_RED + '?x-oss-process=image/resize,m_fixed,h_44,w_44'" />
      </a-badge>
    </div>

    <NameCardStyle
      v-if="isShowMyCard"
      class="cardStyle"
      :data="cardData"
      :is-keep-mode="true"
      size="mini"
      placement="rightBottom"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NameCardStyle from '@/components/website/list/namecardStyle.vue'
import { getMyMemberCard } from '@/api/memberCenter/namecard'

// const
import { DEFAULTS_AVATAR_BIG, ICON_CHAT_DOT_RED } from '@/const/image'

export default {
  name: 'LeftBanner',
  components: {
    NameCardStyle,
  },
  data() {
    return {
      DEFAULTS_AVATAR_BIG,
      ICON_CHAT_DOT_RED,
      // 是否显示我的名片
      isShowMyCard: false,
      cardData: {},
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'chat/currentUser',
      // 洽谈的全部未读数(不包括admin的数据)
      talkUnReadNum: 'chat/talkUnReadNum',
    }),
  },
  methods: {
    // 返回企业主页
    toHomePage(unicode) {
      if (!unicode) {
        return
      }
      this.$utils.toOuterLink(`/${unicode}`)
    },
    // 显示自己的名片
    async getMyCard() {
      if (!this.currentUser) {
        return
      }

      if (Object.keys(this.cardData).length > 0) {
        this.isShowMyCard = true
      } else {
        const { code, data } = await getMyMemberCard()
        if (code === 0) {
          // 显示语言设置
          const lang = this.$store.state.locale

          this.cardData = data.memberCardVO
          /**
           * editBackfill
           * 因为后端可能只返回一种语言, 且顺序不一定正确
           * 中文的排到英文前面, 并且替换空值
           * */
          if (this.currentUser && this.currentUser.mulLangFieldList) {
            this.currentUser.mulLangFieldList.map((item) => {
              if (lang === item.langType) {
                this.currentUser = {
                  ...this.currentUser,
                  ...item,
                }
              }
            })
            this.isShowMyCard = true
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.leftBanner {
  position: relative;
  width: 64px;
  height: 100%;
  background: #26292c;
  display: flex;
  flex-direction: column;
  align-items: center;

  > .myIcon {
    margin-top: 10px;
    border-radius: 6px;
    cursor: pointer;
  }

  > .cardStyle {
    position: absolute;
    z-index: 30;
    left: 100%;
    top: 0;
  }
}
</style>
